import React from "react";
import { string, object } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../Headline";

import "./bigSectionName.m.css";

const BigSectionName = ({ domainSlug, sectionsDataForHeader, domainSectionObj, src, language }) => {
  if (!sectionsDataForHeader) {
    return null;
  }

  const getSetionData = () => {
    if (
      (domainSlug && sectionsDataForHeader.parentSectionId !== domainSectionObj.id) ||
      (sectionsDataForHeader.parentSection && !domainSlug)
    ) {
      return {
        sectionName: sectionsDataForHeader.parentSection,
        sectionUrl: sectionsDataForHeader.parentSectionUrl,
      };
    }

    return {
      sectionName: sectionsDataForHeader.currentSection,
      sectionUrl: sectionsDataForHeader.currentSectionUrl,
    };
  };

  return (
    <li className="section" styleName="section-name-container">
      <Link href={getSetionData().sectionUrl}>
        {src === "section" ? (
          <Headline
            headerLevel={1}
            headlineType={9}
            text={getSetionData().sectionName}
            styleName={`${language}-section-name`}
          />
        ) : (
          getSetionData().sectionName
        )}
      </Link>
    </li>
  );
};

BigSectionName.propTypes = {
  domainSlug: string,
  domainSectionObj: object,
  sectionsDataForHeader: object,
  src: string,
  language: string,
};

export default BigSectionName;
